import { IOrdenacao } from "../../SolicitacaoPlaca/interfaces/IOrdenacao";
import { IFiltrosSolicitacaoTerceiros } from "../interfaces/IFiltrosSolicitacaoTerceiros";

export const FILTROS_SOLICITACAO_TERCEIROS_VAZIOS: IFiltrosSolicitacaoTerceiros =
  {
    pdi: "",
    idEmpresa: null,
    idProcesso: [],
    veiculo: [],
    periodoSolicitacao: null,
  };

export const ORDENACAO_SOLICITACAO_TERCEIROS_PADRAO: IOrdenacao = {
  campo: "dataSolicitacao",
  direcao: "ASC",
};
